export const merchantStorefrontTranslations = {
  en: {
    'storefront.noMerchantId': 'No merchant ID provided',
    'storefront.loadingError': 'Failed to load merchant information',
    'storefront.storeNotFound': 'Store Not Found',
    'storefront.storeNotFoundDesc': "This merchant's store could not be loaded.",
    'storefront.goBack': 'Go Back',
    'storefront.back': 'Back',
    'storefront.website': 'Website',
    'storefront.verified': 'Verified',
    'storefront.aiMenu': '📸 AI Menu',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manual',
    'storefront.searchPlaceholder': 'Search products...',
    'storefront.allCategories': 'All Categories',
    'storefront.sortBy': 'Sort by',
    'storefront.sort.category': 'Category',
    'storefront.sort.name': 'Name',
    'storefront.sort.price': 'Price',
    'storefront.noProducts': 'No products found',
    'storefront.clearSearch': 'Clear search',
  },
  es: {
    'storefront.noMerchantId': 'No se proporcionó ID de comerciante',
    'storefront.loadingError': 'No se pudo cargar la información del comerciante',
    'storefront.storeNotFound': 'Tienda no encontrada',
    'storefront.storeNotFoundDesc': 'No se pudo cargar la tienda de este comerciante.',
    'storefront.goBack': 'Regresar',
    'storefront.back': 'Atrás',
    'storefront.website': 'Sitio Web',
    'storefront.verified': 'Verificado',
    'storefront.aiMenu': '📸 Menú IA',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manual',
    'storefront.searchPlaceholder': 'Buscar productos...',
    'storefront.allCategories': 'Todas las categorías',
    'storefront.sortBy': 'Ordenar por',
    'storefront.sort.category': 'Categoría',
    'storefront.sort.name': 'Nombre',
    'storefront.sort.price': 'Precio',
    'storefront.noProducts': 'No se encontraron productos',
    'storefront.clearSearch': 'Limpiar búsqueda',
  },
  fr: {
    'storefront.noMerchantId': 'Aucun ID de marchand fourni',
    'storefront.loadingError': 'Échec du chargement des informations du marchand',
    'storefront.storeNotFound': 'Boutique introuvable',
    'storefront.storeNotFoundDesc': 'La boutique de ce marchand n\'a pas pu être chargée.',
    'storefront.goBack': 'Retour',
    'storefront.back': 'Retour',
    'storefront.website': 'Site Web',
    'storefront.verified': 'Vérifié',
    'storefront.aiMenu': '📸 Menu IA',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manuel',
    'storefront.searchPlaceholder': 'Rechercher des produits...',
    'storefront.allCategories': 'Toutes les catégories',
    'storefront.sortBy': 'Trier par',
    'storefront.sort.category': 'Catégorie',
    'storefront.sort.name': 'Nom',
    'storefront.sort.price': 'Prix',
    'storefront.noProducts': 'Aucun produit trouvé',
    'storefront.clearSearch': 'Effacer la recherche',
  },
  sq: {
    'storefront.noMerchantId': 'Nuk u dha ID tregtari',
    'storefront.loadingError': 'Dështoi ngarkimi i informacionit të tregtarit',
    'storefront.storeNotFound': 'Dyqani nuk u gjet',
    'storefront.storeNotFoundDesc': 'Dyqani i këtij tregtari nuk mund të ngarkohej.',
    'storefront.goBack': 'Kthehu',
    'storefront.back': 'Kthehu',
    'storefront.website': 'Faqja e Internetit',
    'storefront.verified': 'I verifikuar',
    'storefront.aiMenu': '📸 Menyja AI',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manual',
    'storefront.searchPlaceholder': 'Kërkoni produkte...',
    'storefront.allCategories': 'Të gjitha kategoritë',
    'storefront.sortBy': 'Rendit sipas',
    'storefront.sort.category': 'Kategoria',
    'storefront.sort.name': 'Emri',
    'storefront.sort.price': 'Çmimi',
    'storefront.noProducts': 'Nuk u gjetën produkte',
    'storefront.clearSearch': 'Pastro kërkimin',
  },
  ru: {
    'storefront.noMerchantId': 'ID продавца не предоставлен',
    'storefront.loadingError': 'Не удалось загрузить информацию о продавце',
    'storefront.storeNotFound': 'Магазин не найден',
    'storefront.storeNotFoundDesc': 'Магазин этого продавца не может быть загружен.',
    'storefront.goBack': 'Вернуться',
    'storefront.back': 'Назад',
    'storefront.website': 'Веб-сайт',
    'storefront.verified': 'Проверено',
    'storefront.aiMenu': '📸 AI Меню',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Ручной',
    'storefront.searchPlaceholder': 'Поиск продуктов...',
    'storefront.allCategories': 'Все категории',
    'storefront.sortBy': 'Сортировать по',
    'storefront.sort.category': 'Категория',
    'storefront.sort.name': 'Название',
    'storefront.sort.price': 'Цена',
    'storefront.noProducts': 'Продукты не найдены',
    'storefront.clearSearch': 'Очистить поиск',
  },
  pt: {
    'storefront.noMerchantId': 'Nenhum ID de comerciante fornecido',
    'storefront.loadingError': 'Falha ao carregar informações do comerciante',
    'storefront.storeNotFound': 'Loja Não Encontrada',
    'storefront.storeNotFoundDesc': 'A loja deste comerciante não pôde ser carregada.',
    'storefront.goBack': 'Voltar',
    'storefront.back': 'Voltar',
    'storefront.website': 'Site',
    'storefront.verified': 'Verificado',
    'storefront.aiMenu': '📸 Menu IA',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manual',
    'storefront.searchPlaceholder': 'Buscar produtos...',
    'storefront.allCategories': 'Todas as Categorias',
    'storefront.sortBy': 'Ordenar por',
    'storefront.sort.category': 'Categoria',
    'storefront.sort.name': 'Nome',
    'storefront.sort.price': 'Preço',
    'storefront.noProducts': 'Nenhum produto encontrado',
    'storefront.clearSearch': 'Limpar busca',
  },
  de: {
    'storefront.noMerchantId': 'Keine Händler-ID bereitgestellt',
    'storefront.loadingError': 'Händlerinformationen konnten nicht geladen werden',
    'storefront.storeNotFound': 'Geschäft nicht gefunden',
    'storefront.storeNotFoundDesc': 'Das Geschäft dieses Händlers konnte nicht geladen werden.',
    'storefront.goBack': 'Zurück',
    'storefront.back': 'Zurück',
    'storefront.website': 'Website',
    'storefront.verified': 'Verifiziert',
    'storefront.aiMenu': '📸 KI-Menü',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manuell',
    'storefront.searchPlaceholder': 'Produkte suchen...',
    'storefront.allCategories': 'Alle Kategorien',
    'storefront.sortBy': 'Sortieren nach',
    'storefront.sort.category': 'Kategorie',
    'storefront.sort.name': 'Name',
    'storefront.sort.price': 'Preis',
    'storefront.noProducts': 'Keine Produkte gefunden',
    'storefront.clearSearch': 'Suche löschen',
  },
  ro: {
    'storefront.noMerchantId': 'Nu a fost furnizat ID comerciant',
    'storefront.loadingError': 'Nu s-a putut încărca informațiile comerciantului',
    'storefront.storeNotFound': 'Magazin Negăsit',
    'storefront.storeNotFoundDesc': 'Magazinul acestui comerciant nu a putut fi încărcat.',
    'storefront.goBack': 'Înapoi',
    'storefront.back': 'Înapoi',
    'storefront.website': 'Site Web',
    'storefront.verified': 'Verificat',
    'storefront.aiMenu': '📸 Meniu IA',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Manual',
    'storefront.searchPlaceholder': 'Căutare produse...',
    'storefront.allCategories': 'Toate Categoriile',
    'storefront.sortBy': 'Sortare după',
    'storefront.sort.category': 'Categorie',
    'storefront.sort.name': 'Nume',
    'storefront.sort.price': 'Preț',
    'storefront.noProducts': 'Nu s-au găsit produse',
    'storefront.clearSearch': 'Șterge căutarea',
  },
  sr: {
    'storefront.noMerchantId': 'Није дат ИД трговца',
    'storefront.loadingError': 'Није успело учитавање информација о трговцу',
    'storefront.storeNotFound': 'Продавница није пронађена',
    'storefront.storeNotFoundDesc': 'Продавница овог трговца се не може учитати.',
    'storefront.goBack': 'Врати се',
    'storefront.back': 'Назад',
    'storefront.website': 'Веб сајт',
    'storefront.verified': 'Верификовано',
    'storefront.aiMenu': '📸 АИ мени',
    'storefront.google': '🗺 Гоогле',
    'storefront.manual': '✏ Ручно',
    'storefront.searchPlaceholder': 'Претражите производе...',
    'storefront.allCategories': 'Све категорије',
    'storefront.sortBy': 'Сортирај по',
    'storefront.sort.category': 'Категорија',
    'storefront.sort.name': 'Име',
    'storefront.sort.price': 'Цена',
    'storefront.noProducts': 'Нема пронађених производа',
    'storefront.clearSearch': 'Обриши претрагу',
  },
  pl: {
    'storefront.noMerchantId': 'Nie podano identyfikatora sprzedawcy',
    'storefront.loadingError': 'Nie udało się załadować informacji o sprzedawcy',
    'storefront.storeNotFound': 'Sklep nie znaleziony',
    'storefront.storeNotFoundDesc': 'Nie można załadować sklepu tego sprzedawcy.',
    'storefront.goBack': 'Wróć',
    'storefront.back': 'Wstecz',
    'storefront.website': 'Strona internetowa',
    'storefront.verified': 'Zweryfikowano',
    'storefront.aiMenu': '📸 Menu AI',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Ręczne',
    'storefront.searchPlaceholder': 'Szukaj produktów...',
    'storefront.allCategories': 'Wszystkie kategorie',
    'storefront.sortBy': 'Sortuj według',
    'storefront.sort.category': 'Kategoria',
    'storefront.sort.name': 'Nazwa',
    'storefront.sort.price': 'Cena',
    'storefront.noProducts': 'Nie znaleziono produktów',
    'storefront.clearSearch': 'Wyczyść wyszukiwanie',
  },
  el: {
    'storefront.noMerchantId': 'Δεν παρέχεται ID εμπόρου',
    'storefront.loadingError': 'Αποτυχία φόρτωσης πληροφοριών εμπόρου',
    'storefront.storeNotFound': 'Το κατάστημα δεν βρέθηκε',
    'storefront.storeNotFoundDesc': 'Δεν ήταν δυνατή η φόρτωση του καταστήματος αυτού του εμπόρου.',
    'storefront.goBack': 'Επιστροφή',
    'storefront.back': 'Πίσω',
    'storefront.website': 'Ιστοσελίδα',
    'storefront.verified': 'Επαληθευμένο',
    'storefront.aiMenu': '📸 Μενού AI',
    'storefront.google': '🗺️ Google',
    'storefront.manual': '✏️ Χειροκίνητο',
    'storefront.searchPlaceholder': 'Αναζήτηση προϊόντων...',
    'storefront.allCategories': 'Όλες οι κατηγορίες',
    'storefront.sortBy': 'Ταξινόμηση κατά',
    'storefront.sort.category': 'Κατηγορία',
    'storefront.sort.name': 'Όνομα',
    'storefront.sort.price': 'Τιμή',
    'storefront.noProducts': 'Δεν βρέθηκαν προϊόντα',
    'storefront.clearSearch': 'Καθαρισμός αναζήτησης',
  },
};
